import { render, staticRenderFns } from "./ltqh100g.vue?vue&type=template&id=bc2b0bd8&scoped=true&"
import script from "./ltqh100g.vue?vue&type=script&lang=js&"
export * from "./ltqh100g.vue?vue&type=script&lang=js&"
import style0 from "./ltqh100g.vue?vue&type=style&index=0&id=bc2b0bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b0bd8",
  null
  
)

export default component.exports